export default __webpack_public_path__ + "static/media/web-dev.8c1719d3.png";